import _exists from './exists';
import _isUnique from './isUnique';

class Base {
  constructor(props) {
    this.exists = Base.exists;
    this.isUnique = Base.isUnique;
    this.setState = this.setState;
    this.props = props;
  }

  // Static methods
  static exists(element) {
    return _exists(element);
  }

  static isUnique(element) {
    return _isUnique(element);
  }

  // Non-static methods
  setState(state, callback) {
    this.state = {
      ...this.state,
      ...state,
    };
    if (callback) return callback();
  }
}

export default Base;
